// ============================================================================
// Contenu de l'offre « Recherche de subventions »
// Design validé le 20/08/2026 :
//   docs/superpowers/specs/2026-08-20-recherche-subventions-design.md
//
// ⚠️ LIGNES ROUGES — ne pas les enfreindre en éditant ce fichier :
//   1. AUCUN chiffre de performance (taux de réussite, montants obtenus, nombre
//      de dossiers, note client) tant qu'aucun dossier réel n'est documenté.
//      Le site s'est déjà fait piéger deux fois là-dessus (faux témoignages,
//      « cabinet certifié ») — risque L. 121-2 du Code de la consommation.
//   2. La certification RS7481 porte sur les MARCHÉS PUBLICS. Elle ne couvre
//      pas la recherche de subventions, qui n'est encadrée par aucune
//      certification d'État. Le dire, ne pas le laisser deviner.
//   3. CEE : dispositif cité, jamais un rôle. Hupsoo n'est ni obligé, ni
//      délégataire, ni mandataire CEE (cadre durci en période 6 depuis 2026 :
//      le mandataire doit être déclaré sur chaque dépôt EMMY).
//   4. Aucune garantie d'obtention, sous aucune formulation.
//   5. Les honoraires ne sont pas présentés comme subventionnables.
//
// Les clés `icon` sont résolues par ICONES_SUBVENTIONS dans App.js.
// ============================================================================

export const SUBVENTIONS_ACCROCHE =
  "Vos concurrents ne demandent pas ces aides. Vous non plus — pour l'instant.";

// --- Bloc 1 : le déclic ----------------------------------------------------
export const REGLE_ANTERIORITE = {
  titre: "Une aide se demande avant. Toujours.",
  texte:
    "La quasi-totalité des dispositifs publics exigent que la demande soit déposée — et le plus " +
    "souvent accusée réception — avant tout engagement de la dépense : avant la signature du devis, " +
    "avant le bon de commande, avant le premier acompte. Un dossier déposé après ne devient pas plus " +
    "difficile à défendre : il devient irrecevable. C'est la première raison pour laquelle des " +
    "entreprises parfaitement éligibles ne touchent rien.",
};

// --- Bloc 2 : les quatre niveaux de financement ----------------------------
export const NIVEAUX = [
  {
    icon: "building",
    titre: "Département & agglomération",
    texte:
      "Aides à l'immobilier d'entreprise, à l'emploi local, à la primo-installation. " +
      "Les moins connues, et souvent les moins demandées.",
  },
  {
    icon: "map",
    titre: "Région",
    texte:
      "Le premier financeur des entreprises sur son territoire : investissement productif, " +
      "modernisation de l'outil, export, transition écologique, recrutement.",
  },
  {
    icon: "landmark",
    titre: "État & Bpifrance",
    texte:
      "Subventions, avances remboursables, prêts bonifiés, appels à projets, " +
      "dont les guichets France 2030.",
  },
  {
    icon: "globe",
    titre: "Europe",
    texte:
      "FEDER instruit par votre région, Horizon Europe, LIFE, programmes sectoriels. " +
      "Montants élevés, procédures longues : à engager tôt.",
  },
];

// --- Bloc 3 : les opérateurs sectoriels ------------------------------------
export const OPERATEURS_INTRO =
  "Ce ne sont pas des collectivités, et c'est précisément pour ça qu'on n'y pense pas.";

export const OPERATEURS = [
  "ADEME",
  "Agence de l'eau",
  "FranceAgriMer",
  "Carsat",
  "OPCO",
  "Certificats d'économies d'énergie (CEE)",
  "Chambres consulaires",
];

// --- Bloc 4 : la méthode ---------------------------------------------------
export const ETAPES = [
  {
    n: "01",
    icon: "search",
    titre: "Diagnostic — gratuit",
    texte:
      "45 minutes. Vos projets des dix-huit prochains mois, vos investissements déjà engagés, " +
      "votre effectif, votre implantation, votre secteur. Vous repartez avec une réponse franche : " +
      "il y a quelque chose à aller chercher, ou il n'y a rien.",
  },
  {
    n: "02",
    icon: "list",
    titre: "Cartographie des dispositifs",
    texte:
      "Croisement de votre projet avec les dispositifs des quatre niveaux et des opérateurs " +
      "sectoriels. Vous recevez la liste retenue — montants, taux d'intervention, calendrier de " +
      "dépôt, règles de cumul — et ceux que nous écartons, avec la raison.",
  },
  {
    n: "03",
    icon: "file",
    titre: "Montage et dépôt",
    texte:
      "Rédaction du dossier, plan de financement, pièces justificatives, dépôt sur la plateforme " +
      "de chaque financeur, dans le délai de chacun.",
  },
  {
    n: "04",
    icon: "handshake",
    titre: "Coordination des financeurs",
    texte:
      "Un projet en mobilise rarement un seul. Chacun a son calendrier, son taux, ses règles de " +
      "cumul. Nous tenons le fil à votre place.",
  },
  {
    n: "05",
    icon: "coins",
    titre: "Déblocage et sécurisation des fonds",
    texte:
      "Une subvention notifiée n'est pas une subvention versée. Demandes d'acompte et de solde, " +
      "justificatifs de dépenses, contrôles sur pièces ou sur site.",
  },
];

// --- Bloc 5 : les réserves -------------------------------------------------
export const RESERVES = [
  "Aucune garantie d'obtention : la décision appartient au financeur, jamais au conseil. Toute personne qui vous garantit une subvention vous ment.",
  "Aucun dossier rétroactif : nous ne montons pas de demande pour une dépense déjà engagée.",
  "CEE : nous signalons les opérations éligibles. Nous ne sommes ni obligé, ni délégataire, ni mandataire CEE.",
  "Nos honoraires ne sont pas une dépense subventionnable dans la plupart des dispositifs : ils restent à votre charge.",
  "La certification RS7481 de notre consultante porte sur les marchés publics. Elle ne couvre pas la recherche de subventions, qui n'est encadrée par aucune certification d'État.",
];

// --- Bloc 6 : les engagements (réassurance, à défaut de chiffres) -----------
export const ENGAGEMENTS = [
  "Diagnostic gratuit, sans engagement, et réponse franche s'il n'y a rien à aller chercher.",
  "Le périmètre exact des financeurs sollicités est écrit avant que nous commencions.",
  "Pas d'obtention, pas d'honoraires de succès.",
  "Une seule interlocutrice, partout en France, à distance.",
];

// --- Carte de l'onglet « Offres » ------------------------------------------
export const OFFRE = {
  titre: "Recherche de subventions",
  description: "Identifier et aller chercher les aides mobilisables sur vos projets",
  features: [
    "Diagnostic d'éligibilité gratuit",
    "Cartographie des dispositifs (département, région, État, Europe)",
    "Opérateurs sectoriels : ADEME, Agence de l'eau, FranceAgriMer, Carsat, OPCO",
    "Montage et dépôt des dossiers",
    "Coordination des financeurs sollicités",
    "Suivi jusqu'au versement des fonds",
  ],
  cta: "Demander un diagnostic gratuit",
};

// --- FAQ -------------------------------------------------------------------
export const FAQ = [
  {
    question: "Mon entreprise est trop petite pour être aidée ?",
    answer:
      "C'est l'idée reçue la plus coûteuse. Les dispositifs départementaux et régionaux visent " +
      "explicitement les TPE, et certains n'ont que peu de demandeurs — non parce qu'ils sont " +
      "fermés, mais parce qu'ils sont inconnus. La taille de votre entreprise n'est presque jamais " +
      "le critère qui bloque ; le calendrier de dépôt, lui, l'est souvent.",
  },
  {
    question: "Ces aides ne sont-elles pas réservées à l'innovation ?",
    answer:
      "Non. L'innovation est la partie visible parce que c'est celle que les grands cabinets " +
      "vendent. Les dispositifs les plus mobilisables par une TPE portent sur l'investissement " +
      "productif, l'immobilier d'entreprise, la numérisation, la décarbonation, le recrutement, " +
      "l'export ou la formation.",
  },
  {
    question: "Pourquoi payer, alors que la CCI et Bpifrance informent gratuitement ?",
    answer:
      "Les ressources publiques — les-aides.fr, aides-territoires, votre conseiller régional — " +
      "sont gratuites et de bonne qualité : si vous avez le temps de les explorer, faites-le, nous " +
      "vous le dirons. Ce que nous vendons n'est pas l'information : c'est le temps que vous n'y " +
      "passerez pas, le croisement des dispositifs cumulables entre eux, et un dossier qui se juge " +
      "sur la forme autant que sur le fond. Si le diagnostic conclut qu'un appel à votre conseiller " +
      "régional suffit, nous vous le dirons aussi.",
  },
  {
    question: "Combien de temps avant de toucher les fonds ?",
    answer:
      "Cela dépend entièrement du dispositif : de quelques semaines pour une aide départementale à " +
      "plus d'un an entre le dépôt et le versement du solde sur un programme européen. Retenez " +
      "surtout que notification ne vaut pas versement : le plan de trésorerie se construit sur les " +
      "dates de versement, pas sur la date de décision.",
  },
];
